import { Block, Flex, Typography } from '@aloft/toolkit-sui';

export const EmptyCompSelectionDetails = () => (
  <Flex justifyContent="center" height="100%" alignItems="center">
    <Block backgroundColor="surface1" borderRadius="0.375rem" padding="1rem">
      <Typography>Select a property to see details</Typography>
    </Block>
  </Flex>
);
